/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Suppression } from 'cio/utils/email-suppression-list';

interface TabsArgs {
  categories: Record<string, string>;
  hasCounts: boolean;
  onCategoryChange: (category: string) => unknown;
  suppressionsByCategory: Record<string, Suppression[]>;
  category: string;
}

export default class Tabs extends Component<TabsArgs> {}
